import { render, staticRenderFns } from "./NewsDetial.vue?vue&type=template&id=9b599934&"
import script from "./NewsDetial.vue?vue&type=script&lang=js&"
export * from "./NewsDetial.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetial.vue?vue&type=style&index=0&id=9b599934&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports